import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord, SalesSubCategoryModel } from '.';

export interface ISalesItemDiscountSubcategoryModel extends IModel {
  salesItemDiscountSubcategoryId: number;
  salesItemId: number;
  salesSubCategoryId: number;
  salesSubCategory: SalesSubCategoryModel | undefined;
}
export class SalesItemDiscountSubcategoryModel
  extends Model
  implements ModelRecord<ISalesItemDiscountSubcategoryModel>
{
  salesItemDiscountSubcategoryId: number;
  salesItemId: number;
  salesSubCategoryId: number;
  salesSubCategory: SalesSubCategoryModel | undefined;

  constructor(params?: Partial<ISalesItemDiscountSubcategoryModel>) {
    super(params);
    this.salesItemDiscountSubcategoryId = defaultTo(
      params?.salesItemDiscountSubcategoryId,
      0,
    );
    this.salesItemId = defaultTo(params?.salesItemId, 0);
    this.salesSubCategoryId = defaultTo(params?.salesSubCategoryId, 0);
    this.salesSubCategory = params?.salesSubCategory
      ? new SalesSubCategoryModel(params?.salesSubCategory)
      : undefined;
  }
}
